/**
 * Adapted fprm prosemirror-markdown.
 *
 * We only need to override the nodes and marks that are distinct form the default
 * prosemirror-markdown schema.
 *
 * See https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts
 * for how the default nodes are implemented.
 *
 */

import {
    defaultMarkdownSerializer,
    MarkdownSerializer,
    MarkdownSerializerState,
} from "prosemirror-markdown";
import { Node } from "prosemirror-model";

import { EditorConfig } from "@/wc/text-editor/lib/core/config";

export const serialize = (config: EditorConfig, doc: Node) => {
    const serializerConfig = config.serializerConfig();
    return new MarkdownSerializer(
        serializerConfig.nodes,
        serializerConfig.marks,
        serializerConfig.options
    ).serialize(doc);
};

export const baseSerializerConfig = {
    nodes: {
        ...defaultMarkdownSerializer.nodes,
        // Override text node serialization to prevent newline escaping
        text(state: MarkdownSerializerState, node: Node) {
            state.text(node.text || "");
        },
    },
    marks: defaultMarkdownSerializer.marks,
    options: defaultMarkdownSerializer.options,
};
